import {track} from "./lib/track";

console.log(`${process.env.PACKAGE_VERSION}, ${process.env.BUILD_DATE}`);

export * from "../../shared/scripts/login";
export * from "../../shared/scripts/offer";

// Generate a UUID v4 for device identification if it doesn't exist
if (!document.cookie.includes("tid=")) {
  document.cookie = `tid=${crypto.randomUUID()}; path=/; max-age=${60 * 60 * 24 * 365}`; // 1 year expiry
}

// @ts-expect-error - window.track
window.track = track;
